import {
    resetPromoFinancingData,
    SET_PAYMENT_AUTH_FAILED,
} from 'yoda-checkout-components/lib/actionTypes/PlaceOrderActionTypes';
import * as actionTypes from '../actionTypes/PaymentActionTypes';

export default function PaymentReducer(state = {}, action) {
    // NOSONAR
    switch (action.type) {
        case actionTypes.HANDLE_ORDER_PAYMENT_INFO: {
            if (state.currSelectId) {
                return state;
            }
            const draftOrderCreditCardInfo = {
                creditCardDetail: action.payload.creditCardInfo || {},
                relationId: action.payload.currSelectId,
            };
            return {
                ...state,
                creditCardInfo:
                    (action.payload.creditCardInfo &&
                        (action.payload.creditCardInfo.cardType ||
                            action.payload.creditCardInfo.billingAddress) &&
                        action.payload.creditCardInfo) ||
                    (action.payload.creditCardInfo && {
                        ...state.creditCardInfo,
                        ...action.payload.creditCardInfo,
                    }) ||
                    {},
                draftOrderCreditCardInfo,
                currSelectId: action.payload.currSelectId || state.currSelectId,
            };
        }

        case actionTypes.GET_PROMO_FINANCING_OFFERS_SUCCESS: {
            return { ...state, promoFinancingData: action.promoFinancingResponse };
        }

        case resetPromoFinancingData: {
            return { ...state, promoFinancingData: {} };
        }

        case actionTypes.SET_REWARD_PROMO_FINANCE_DECISION: {
            return { ...state, rewardOrPromoFinanceData: action.payload };
        }

        case SET_PAYMENT_AUTH_FAILED: {
            return { ...state, paymentAuthFailed: action.payload };
        }

        default:
            return state;
    }
}
